import React from 'react'
import HerosectionHeader from '../Componet/Herosection/HerosectionHeader';
import { Container, Row } from 'reactstrap';
import { Helmet } from 'react-helmet-async';

const ABOUT_US_ITEMS = [
    {
        title: "Convenience",
        description: "Vehicle inspections shouldn't require unnecessary trips to an inspection shop.",
    },
    {
        title: "Professional Guidance",
        description: "A live inspector guides you through each required inspection point during your appointment.",
    },
    {
        title: "Simple Process",
        description: "Book online, complete your inspection through video, and receive your inspection form electronically.",
    }
];

const AboutUs = () => {
    return (
        <>
            <Helmet>
                <title>RideInspector | About Us</title>
                <meta name="description" content="Learn more about Inspectiver, our mission, our experienced inspectors, and how we ensure transparency and confidence in every inspection." />
                <meta name="keywords" content="pre purchase car inspection, pre purchase car inspection near me, Inspectiver, mobile vehicle inspection, about car inspections, vehicle inspection company, Inspectiver mission" />
                <link rel="canonical" href="/about-us" />
            </Helmet>
            <HerosectionHeader name={"About Us"} />
            <div className="page-content">
                <section>
                    <Container>
                        <Row>
                            <div className="mt-2 col-md-12 col-lg-12">
                                <div className="d-flex justify-content-between">
                                    <div className="me-3"></div>
                                    <div>
                                        <h5 className="mb-2">Vehicle Inspections Made Simple</h5>
                                        <p className="mb-0">RideInspector makes vehicle inspections easier by bringing the inspection process directly to your phone. Through
                                            live video inspections, drivers can complete eligible vehicle inspections without making a trip to an inspection shop.</p>
                                        <p className="mb-0">Our goal is simple: <strong>save drivers time and make the vehicle inspection process more convenient.</strong></p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="mt-5 col-md-12 col-lg-12">
                                <div className="d-flex ">
                                    <div className="me-3"></div>
                                    <div>
                                        <h5 className="mb-2">About RideInspector</h5>
                                        <p className="mb-0">RideInspector provides online vehicle inspections for Uber, Lyft, Turo, and other eligible platforms. Our live video
                                            inspection process connects you with an inspector who guides you through the required inspection points on your
                                            vehicle.</p>
                                        <p className="mb-0">
                                            From scheduling your appointment to receiving your completed inspection form, the process is designed to be
                                            simple, convenient, and completed remotely.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="mt-5 col-md-12 col-lg-12">
                                <div className="d-flex">
                                    <div className="me-3"></div>
                                    <div>
                                        <h5 className="mb-2">Our Story</h5>
                                        <p className="mb-0">RideInspector was created by the team behind <strong>Inspectiver</strong>, a nationwide vehicle inspection company providing
                                            comprehensive on-site pre-purchase inspections.</p>
                                        <p className="mb-0">
                                            After building an inspection network and helping vehicle buyers across the country, we saw an opportunity to make
                                            simpler vehicle inspections more convenient.
                                        </p>
                                        <p className="mb-0">
                                            RideInspector was created to bring that experience into a streamlined online process, allowing eligible inspections to
                                            be completed through a live video call from your phone.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </section>
                <div className="container pb-5">
                    <h2 className="fw-bold text-dark text-center">
                        What We Believe
                    </h2>
                    <div className="row border rounded g-0 mt-3">
                        {ABOUT_US_ITEMS.map((item, index) => (
                            <div
                                key={item.title}
                                className={`col-6 col-md-4 text-center px-4 py-4 ${index !== ABOUT_US_ITEMS.length - 1 ? "border-end" : ""
                                    }`}
                            >
                                <div className="fw-bold text-dark mb-1">{item.title}</div>
                                <div className="text-secondary small">{item.description}</div>
                            </div>
                        ))}
                    </div>
                </div>


            </div>
        </>
    )
}

export default AboutUs
